module.exports = __webpack_public_path__ + "img/mexico.22c11f5e.svg";